import { useRef, useEffect } from "react";
import { Litepicker } from "litepicker";
import 'litepicker/dist/plugins/ranges';
import Form from "react-bootstrap/Form";
import { Calendar } from "react-feather";

export default function DateRangeField({
                                         startDate,
                                         endDate,
                                         fromFieldRef,
                                         toFieldRef
}) {
  const inputRef = useRef(null);
  const pickerRef = useRef(null);

  useEffect(() => {
    if (pickerRef.current) {
      pickerRef.current.destroy();
    }

    pickerRef.current = new Litepicker({
      element: inputRef.current,
      startDate: startDate,
      endDate: endDate,
      autoApply: true,
      singleMode: false,
      numberOfMonths: 2,
      numberOfColumns: 2,
      mobileFriendly: true,
      format: 'MMM DD, YYYY',
      plugins: ['ranges'],
      onChange: (e) => {
        console.log(`range: ${e.target.value}`);
      },
      setup: (picker) => {
        picker.on("selected", (date1, date2, getDate) => {
          if (fromFieldRef && fromFieldRef.current) {
            fromFieldRef.current.value = date1.dateInstance;
          }

          if (toFieldRef && toFieldRef.current) {
            toFieldRef.current.value = date2.dateInstance;
          }

          console.log(`date1: ${date1}, date2: ${date2}`);
        });
      }
    });
  }, [startDate, endDate, fromFieldRef, toFieldRef]);

  return (
    <div className="input-group input-group-joined">
      <span className="input-group-text">
        <Calendar/>
      </span>
      <Form.Control
        defaultValue=""
        onChange={(e) => {
          //console.log(`range: ${e.target.value}`);
        }}
        ref={inputRef}
        placeholder="Select date range..."
        className="form-control ps-0 pointer"
      />
      {fromFieldRef &&
        <Form.Control type="hidden" defaultValue={startDate} ref={fromFieldRef} className="small mb-1"/>}
      {toFieldRef &&
        <Form.Control type="hidden" defaultValue={endDate} ref={toFieldRef} className="small mb-1"/>}
    </div>);
}
